import { render, staticRenderFns } from "./BillResume.vue?vue&type=template&id=6cb84a54&"
import script from "./BillResume.vue?vue&type=script&lang=js&"
export * from "./BillResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports